import pino from 'pino';

const logger = pino({
  name: 'root',
  level: 'debug',
  redact: ['email', 'password'],
  browser: {
    serialize: true,
  },
  transport:
    import.meta.env.NODE_ENV === 'production' || !import.meta.env.SSR
      ? undefined
      : { target: 'pino-pretty', options: { colorize: true } },
});

export const createLogger = (name: string) => {
  return logger.child({ name });
};
